import React from 'react';

// Common country codes for phone input
const COUNTRY_CODES = [
    { code: '+44', country: 'GB', name: 'United Kingdom' },
    { code: '+1', country: 'US', name: 'United States' },
    { code: '+1', country: 'CA', name: 'Canada' },
    { code: '+91', country: 'IN', name: 'India' },
    { code: '+61', country: 'AU', name: 'Australia' },
    { code: '+49', country: 'DE', name: 'Germany' },
    { code: '+33', country: 'FR', name: 'France' },
    { code: '+971', country: 'AE', name: 'UAE' },
    { code: '+966', country: 'SA', name: 'Saudi Arabia' },
    { code: '+92', country: 'PK', name: 'Pakistan' },
    { code: '+880', country: 'BD', name: 'Bangladesh' },
    { code: '+234', country: 'NG', name: 'Nigeria' },
    { code: '+86', country: 'CN', name: 'China' },
    { code: '+81', country: 'JP', name: 'Japan' },
    { code: '+82', country: 'KR', name: 'South Korea' },
    { code: '+65', country: 'SG', name: 'Singapore' },
    { code: '+60', country: 'MY', name: 'Malaysia' },
    { code: '+63', country: 'PH', name: 'Philippines' },
    { code: '+27', country: 'ZA', name: 'South Africa' },
    { code: '+20', country: 'EG', name: 'Egypt' },
];

interface PhoneInputNativeProps {
    phone: string;
    countryCode: string;
    onPhoneChange: (phone: string) => void;
    onCountryCodeChange: (code: string, country: string) => void;
}

const PhoneInputNative: React.FC<PhoneInputNativeProps> = ({
    phone,
    countryCode,
    onPhoneChange,
    onCountryCodeChange,
}) => {
    const handleCountryCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selected = COUNTRY_CODES.find(c => c.code === e.target.value);
        if (selected) {
            onCountryCodeChange(selected.code, selected.country);
        }
    };

    return (
        <div className="flex gap-2">
            <select
                value={countryCode}
                onChange={handleCountryCodeChange}
                className="w-28 p-3 bg-gray-50 border border-gray-200 focus:border-[#009B8F] outline-none text-sm"
            >
                {COUNTRY_CODES.map((c, idx) => (
                    <option key={idx} value={c.code}>{c.code} {c.country}</option>
                ))}
            </select>
            <input
                type="tel"
                value={phone}
                onChange={(e) => onPhoneChange(e.target.value)}
                className="flex-1 p-3 bg-gray-50 border border-gray-200 focus:border-[#009B8F] focus:ring-1 focus:ring-[#009B8F] outline-none transition-all"
                placeholder="Phone number"
            />
        </div>
    );
};

export default PhoneInputNative;
export { COUNTRY_CODES };
